import React from 'react';

/* The shape of the page that is coming, rather than the word "loading". The
 * widths are fixed rather than random so a re-render during the fetch does not
 * make the placeholder twitch. */

const CARDS = [0, 1, 2, 3, 4, 5];

export default function DetailSkeleton() {
  return (
    <div className="tw-detail" aria-busy="true" aria-label="Loading">
      <div className="tw-detail-head">
        <div className="tw-shimmer" style={{ width: '46%', height: 26 }} />
        <div className="tw-shimmer" style={{ width: '28%', height: 12, marginTop: 14 }} />
      </div>
      <div className="tw-block">
        <div className="tw-kv">
          {CARDS.map((i) => (
            <div key={i}>
              <div className="tw-shimmer" style={{ width: '58%', height: 20 }} />
              <div className="tw-shimmer" style={{ width: '82%', height: 9, marginTop: 10 }} />
            </div>
          ))}
        </div>
      </div>
      <div className="tw-block">
        <div className="tw-shimmer" style={{ width: '22%', height: 14 }} />
        <div className="tw-shimmer" style={{ height: 320, marginTop: 13, borderRadius: 12 }} />
      </div>
    </div>
  );
}
